import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FormGuard } from 'src/app/shared/guards/form.guard';

import { InformationDocumentationComponent } from './information-documentation/information-documentation-page.component';
import { EligibilityCheckComponent } from './locate-property-page/eligibility-check/eligibility-check.component';
import { IneligibleNoticeComponent } from './locate-property-page/ineligible-notice/ineligible-notice.component';
import { LocatePropertyPageComponent } from './locate-property-page/locate-property-page.component';
import { SelectParcelsComponent } from './locate-property-page/select-parcels/select-parcels.component';
import { NewSitePageComponent } from './new-site-page/new-site-page.component';
import { NewSiteStepThreeComponent } from './new-site-step-three/new-site-step-three.component';
import { NewSiteStepTwoComponent } from './new-site-step-two/new-site-step-two.component';
import { SelectOfferComponent } from './select-offer/select-offer.component';
import { EligibilityQuestionsComponent } from './submit-site/eligibility-questions/eligibility-questions.component';
import { SubmitSiteComponent } from './submit-site/submit-site-page/submit-site-page.component';

import { AuthGuard } from '../../core/auth/auth.guard';
import { CanDeactivateEditMapGuard } from '../../core/auth/edit-map.guard';
import { VerifiedGuard } from '../../core/auth/verified.guard';
import { SharedModule } from '../../shared';
import { NewSiteStepOneComponent } from '../../shared/components/new-site-step-one/new-site-step-one.component';
import { NewSiteStepOneAndAHalfComponent } from '../../shared/components/new-site-step-one-and-a-half/new-site-step-one-and-a-half.component';
import { MapLayersPageComponent } from '../../shared-map/components/map-layers-pages/map-layers-page.component';
import { SharedMapModule } from '../../shared-map/shared-map.module';

const routes: Routes = [
  {
    path: ':id/locate-property',
    component: LocatePropertyPageComponent,
    children: [
      {
        path: '',
        redirectTo: 'select-parcels',
        pathMatch: 'full',
      },
      {
        path: 'select-parcels',
        component: SelectParcelsComponent,
        canDeactivate: [FormGuard],
      },
      {
        path: 'eligibility-check',
        component: EligibilityCheckComponent,
        canDeactivate: [FormGuard],
      },
      {
        path: 'ineligible',
        component: IneligibleNoticeComponent,
        canDeactivate: [FormGuard],
      },
    ],
  },
  {
    path: 'new-site',
    canActivate: [VerifiedGuard, AuthGuard],
    component: NewSitePageComponent,
    children: [
      {
        path: '',
        component: NewSiteStepOneComponent,
        canDeactivate: [FormGuard],
        pathMatch: 'full',
      },
      {
        path: 'step-one-and-a-half',
        component: NewSiteStepOneAndAHalfComponent,
      },
      {
        path: 'step-two',
        component: NewSiteStepTwoComponent,
        canDeactivate: [FormGuard],
      },
      {
        path: 'step-three',
        component: NewSiteStepThreeComponent,
        canDeactivate: [FormGuard],
      },
    ],
  },
  {
    path: ':id/map-site',
    component: MapLayersPageComponent,
    canDeactivate: [CanDeactivateEditMapGuard],
  },
  {
    path: ':id/eligibility-questions',
    component: EligibilityQuestionsComponent,
    canDeactivate: [FormGuard],
  },
  {
    path: ':id/site-offer',
    component: SelectOfferComponent,
  },
  {
    path: ':id/information-documentation',
    component: InformationDocumentationComponent,
    canDeactivate: [FormGuard],
  },
  {
    path: ':id/submit-site',
    component: SubmitSiteComponent,
    canDeactivate: [FormGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), SharedModule, SharedMapModule],
  exports: [RouterModule],
})
export class SiteRoutingModule {}
